import { createContext, useState, useCallback } from "react";
import { getMenu } from "./api";
import { route2 } from "./../../template/ProtectedRoutes";
import { MergeArrayByKey } from "./../../utils/common-function";
export const MenuContext = createContext(null);

const useMenu = () => {
  const [MenuList, setMenuList] = useState([]);
  const [ScreenList, setScreenList] = useState([]);
  const GetMenuList = useCallback(
    async () => {
      let data = await getMenu();
      let datascreen=[];
      if (data) {
        data.forEach(el => {
          let menu = MergeArrayByKey(el.Modules, "MODULE_NAME", route2, "ScreenName");
          el.Modules = menu
        });

        data.forEach((item, i) => {
            item.Modules.forEach(x => {
              datascreen.push({MODULE_NAME: x.MODULE_NAME});
              if(x.ID === "2"){ //Text Loader
                datascreen.push({MODULE_NAME: "Import CSV"});
              }
              if(x.ID === "3"){ //Decrypt Export
                datascreen.push({MODULE_NAME: "Decrypt Table"});
              }
            })
        });
        setMenuList(data);
        setScreenList(datascreen);
      }
    },
    [setMenuList, setScreenList],
  )

  return { GetMenuList, MenuList, ScreenList };
};

export const MenuContextProvider = ({ children }) => {
  return (
    <MenuContext.Provider value={useMenu()}>{children}</MenuContext.Provider>
  );
};
